import axios from "axios";
import i18n from "../i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

// Dev : proxy CRA/craco (/api → 8010, pas de CORS). Prod distante : URL absolue ou /api same-host.
const isRemoteProduction =
  BACKEND_URL &&
  !BACKEND_URL.includes("localhost") &&
  !BACKEND_URL.includes("127.0.0.1") &&
  !BACKEND_URL.includes("preview.emergentagent.com");

export const API_BASE =
  process.env.NODE_ENV === "development"
    ? "/api"
    : isRemoteProduction
      ? `${BACKEND_URL}/api`
      : "/api";

// Create a pre-configured axios instance that automatically attaches the auth token
const apiClient = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

function syncAcceptLanguage() {
  const lang = i18n.language?.startsWith("en") ? "en" : "fr";
  apiClient.defaults.headers.common["Accept-Language"] = lang;
}

syncAcceptLanguage();
i18n.on("languageChanged", syncAcceptLanguage);

// Request interceptor: always read from localStorage to avoid stale React state
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("omu_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const lang = i18n.language?.startsWith("en") ? "en" : "fr";
  config.headers["Accept-Language"] = lang;
  return config;
});

// Response interceptor: redirect on 401 (optional)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - let components handle this
      console.warn("Auth error 401 - token may be expired");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
